/*
 * @Author: your name
 * @Date: 2021-11-11 13:10:32
 * @LastEditTime: 2022-05-06 04:40:02
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\components\tabbar\index.js
 */
export default{
    data() {
        return {
        }
    },
    props:{
        title: {
            type: String,
            default: '数字化全域经销商体系'
        },
        rightText: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: ''
        },
    },
    methods: {
        clickLeft() {
            setTimeout(() => {
                this.$router.go(-1)
            }, 80);
        },
        clickRight() {
            setTimeout(() => {
                this.$emit('click-right')
            }, 80);
        }
    },
    computed: {
        getOpenInWechat() {
            return this.$store.state.app.system.openInWechat
        },
    }
}